import type { AlertAppearance } from '@ksyos/design-system';
import { Alert } from '@ksyos/design-system';

export type DisplayMessageProps = {
    message?: string;
    messageType?: AlertAppearance;
    onClose?: () => void;
};

export function DisplayMessage({ message, messageType = 'info', onClose }: Readonly<DisplayMessageProps>) {
    if (!message) {
        return null;
    }

    return (
        <Alert
            appearance={messageType}
            hasIcon={true}
            isClosable={!!onClose}
            onClose={onClose}
        >
            {message}
        </Alert>
    );
}
